export const CHANGE_MONTH = 'CHANGE_MONTH';
export const DAY_SELECTED = 'DAY_SELECTED';
export const WEEK_SELECTED = 'WEEK_SELECTED';


// WEBPACK FOOTER //
// ./src/actions.js